import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";
import {
	ScConnectedInactiveSettings,
	ScConnectedNotice,
	ScConnectedToggle,
} from "@/components/features/items/edit/plan/_shared/ui/components/sc-connected";

import { QuestionDayTripPlanCancelPolicy } from "./cancel-policy";
import { QuestionPlanKidsPolicyRoot } from "./kids-policy";
import { QuestionPlanPrice } from "./price";
import { PriceSettingDescription } from "./price-setting-description";
import { QuestionPlanRoomStaticPrice } from "./room-static-price";
import { useDayTripPlanScConnected } from "./sc-connected";

import type { DayTripPlanCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	priceAndPolicy: DayTripPlanCategoriesAndManagerStore["priceAndPolicy"];
};

export const QuestionDayTripPlanPriceAndPolicy = ({ priceAndPolicy }: Props) => {
	const { shouldShow, isSCConnected, siteControllerType, onToggle } = useDayTripPlanScConnected();

	return (
		<>
			<FeatureIslandMainWithCategoryWrapper islandTitle="料金設定について" categoryStore={priceAndPolicy}>
				<PriceSettingDescription />
				{shouldShow && isSCConnected ? (
					<div className="space-y-4">
						<ScConnectedToggle isSCConnected={isSCConnected} onToggle={onToggle} />
						{isSCConnected.value ? <ScConnectedNotice siteControllerType={siteControllerType} /> : null}
					</div>
				) : null}
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper
				islandTitle="部屋料金設定"
				categoryStore={priceAndPolicy}
			>
				<ScConnectedInactiveSettings inactive={Boolean(isSCConnected?.value)}>
					<QuestionPlanRoomStaticPrice />
				</ScConnectedInactiveSettings>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper
				islandTitle="プラン料金設定"
				categoryStore={priceAndPolicy}
			>
				<ScConnectedInactiveSettings inactive={Boolean(isSCConnected?.value)}>
					<QuestionPlanPrice />
					<QuestionPlanKidsPolicyRoot />
				</ScConnectedInactiveSettings>
			</FeatureIslandMainWithCategoryWrapper>

			<FeatureIslandMainWithCategoryWrapper
				islandTitle="プラン独自のキャンセルポリシー"
				categoryStore={priceAndPolicy}
			>
				<QuestionDayTripPlanCancelPolicy />
			</FeatureIslandMainWithCategoryWrapper>
		</>
	);
};

QuestionDayTripPlanPriceAndPolicy.displayName = "QuestionDayTripPlanPriceAndPolicy";
